import { Logger } from '../../stores/logger/Logger';
import * as _ from 'lodash';

let ErrorHandler = {
  handleError: function (error: any, logger: Logger) {
    let message = error;

    if (_.isObject(error)) {
      if (_.isUndefined(error.message)) {
        message = "Unknown error type caught: " + error;
      } else {
        message = error.message;
      }
    }

    logger.addError(message);
    console.log(error);
  }
};

export default ErrorHandler;


// WEBPACK FOOTER //
// ./src/services/errorhandler/ErrorHandler.ts